import { useRef } from "react";
import { motion, useInView, useReducedMotion } from "framer-motion";
import "./index.css";
import emcImage from "../assets/EMC.webp";

export default function App() {
  const rootRef = useRef(null);
  const prefersReducedMotion = useReducedMotion();
  const inView = useInView(rootRef, { margin: "-10% 0px", once: true });
  const shouldAnimate = inView && !prefersReducedMotion;

  const fade = (delay = 0) => ({
    initial: { opacity: 0, y: 18 },
    animate: shouldAnimate ? { opacity: 1, y: 0 } : { opacity: 1, y: 0 },
    transition: { duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }
  });

  return (
    <section ref={rootRef} className="emc">
      <div className="emc-inner">
        <motion.div
          className="emc-media"
          initial={{ opacity: 0, x: -20 }}
          animate={
            shouldAnimate ? { opacity: 1, x: 0 } : { opacity: 1, x: 0 }
          }
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <img
            src={emcImage}
            alt="F2 Labs EMC test report cover page for Arsenal PC AI workstations"
            className="emc-image"
            loading="lazy"
            decoding="async"
          />
        </motion.div>

        <div className="emc-content">
          <motion.span className="emc-eyebrow" {...fade(0.1)}>
            <span className="emc-eyebrow-mark" />
            Independent EMC Testing
          </motion.span>

          <motion.h2 className="emc-title" {...fade(0.2)}>
            Tested to{" "}
            <span className="emc-title-accent">FCC and ICES</span> Standards
          </motion.h2>

          <motion.p className="emc-body" {...fade(0.3)}>
            Our Meshify 2XL AI Workstation was independently tested by F2 Labs,
            an accredited EMC laboratory, and found to comply with FCC Part 15
            Class B (US) and ICES-003 (Canada) emissions standards. Most custom
            builders skip this. We test because professional environments
            deserve the same standards as the big OEMs.
          </motion.p>
        </div>
      </div>
    </section>
  );
}
